import React from 'react';
import PropTypes from 'prop-types';
import './text-area.style.scss';

/**
 * Class representing text area input.
 * @extends React.Component
 * */
class TextArea extends React.Component {

  /**
   * Bubble up focus out event.
   * */
  handleFocusOut = (event) => {
    const { onFocusOut } = this.props;
    onFocusOut(event);
  };


  /**
   * Bubble up value change event.
   * */
  handleValueChange = (event) => {
    const { onValueChange } = this.props;
    onValueChange(event);
  };

  render() {
    const {
      className,
      isDisabled,
      value
    } = this.props;

    return (
      <textarea
        className={`${className} ${isDisabled ? 'disabled' : ''}`}
        disabled={isDisabled}
        onBlur={this.handleFocusOut}
        onChange={this.handleValueChange}
        value={value}
        rows="3"
      />
    );
  }

}

export default TextArea;

TextArea.propTypes = {
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  onValueChange: PropTypes.func.isRequired,
  onFocusOut: PropTypes.func.isRequired,
  value: PropTypes.string,
};

TextArea.defaultProps = {
  className: '',
  isDisabled: false,
  value: ''
};



// WEBPACK FOOTER //
// ./src/common/components/text-area/text-area.component.js